module.exports = __webpack_public_path__ + "img/landing1.24c38048.png";